export const DEFAULT_PANELS_DIR = "panels";
